export default __webpack_public_path__ + "static/media/Group 11810.6fd160e2.svg";